/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NavigationListComponentDisplay } from "cms/components/components/navigation-list/display";
import { NavigationListComponentEditor } from "cms/components/components/navigation-list/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const NavigationListComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <NavigationListComponentDisplay />,
        editComponent: <NavigationListComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NavigationListComponent.displayName = "NavigationListComponent";
export { NavigationListComponent };
